export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50"></div>
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20collage%20of%20contemporary%20fashion%20items%20sneakers%20hoodies%20caps%20and%20accessories%20scattered%20organically%20with%20varying%20angles%20on%20warm%20off%20white%20canvas%20texture%20soft%20morning%20light%20editorial%20magazine%20spread%20style%20clean%20aesthetic%20harmonious%20color%20palette&width=1920&height=1200&seq=hero-collage-v4&orientation=landscape"
          alt="MuleBuy Spreadsheet product categories collage"
          className="w-full h-full object-cover opacity-20"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/5 z-[1]"></div>

      <div className="relative z-10 w-full max-w-[960px] mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-background-100/80 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="text-xs md:text-sm font-label font-medium text-foreground-700">
            2026 Buying Guide
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-tight mb-6">
          MuleBuy Spreadsheet Hub
          <br />
          <span className="text-foreground-700 font-normal text-3xl md:text-5xl lg:text-6xl">
            The Ultimate Guide to MuleBuy Spreadsheets
          </span>
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-[640px] mx-auto mb-10 leading-relaxed">
          Discover, compare, and use the most reliable <strong>mulebuy spreadsheet</strong> lists to find trending products, trusted agents, and optimized buying strategies in 2026.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#categories"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-label font-semibold text-sm cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Explore MuleBuy Spreadsheets
            <i className="ri-arrow-down-line text-base"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-foreground-300 text-foreground-900 font-label font-semibold text-sm cursor-pointer hover:bg-foreground-50 transition-colors whitespace-nowrap"
          >
            Visit Main Platform
            <i className="ri-external-link-line text-base"></i>
          </a>
          <a
            href="/mulebuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-secondary-100 text-secondary-900 font-label font-semibold text-sm cursor-pointer hover:bg-secondary-200 transition-colors whitespace-nowrap"
          >
            Read Full Guide
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-12 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i>
            Updated Daily Spreadsheet Database
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i>
            Verified Agent Sources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-500 text-sm"></i>
            Beginner-Friendly Guides
          </span>
        </div>
      </div>
    </section>
  );
}